import Parse from "parse/dist/parse.min.js";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import "./Modals.css";
import { useEffect, useRef, useState } from "react";
import { ColoredDivider } from "../ColoredDivider/ColoredDivider";
import { OrbitProgress } from "react-loading-indicators";
import { Form } from "react-bootstrap";
import { TransformComponent, TransformWrapper } from "react-zoom-pan-pinch";
import Background from "../../assets/images/backgroundMenuPage.png";
import { PGSDK } from "../../pgsdk";
import { globalCounter } from "../HomePage/HomePage.js";
import { EachDecision } from "../EachDecision/EachDecision.js";
import Confetti from "../Confetti/confetti.js";
import DiscourseForum from "../Discourse/discourse-forum.js";
import center from "../../assets/images/center.png";
import left from "../../assets/images/left.png";
import right from "../../assets/images/right.png";
import done_right from "../../assets/images/done_right.png";
import done_center from "../../assets/images/done_center.png";
import done_left from "../../assets/images/done_left.png";
import defaultAvatar from "../../assets/images/avatar.png";

export const ConfirmModal = ({
  isConfirmModalOpen,
  areYouSureTitle,
  handleCancelClick,
  handleDecisionClick,
  noTitle,
  yesTitle,
  languageString,
}) => {
  return (
    <Modal
      centered
      show={isConfirmModalOpen}
      onHide={handleCancelClick}
      className="confirm-modal"
    >
      <Modal.Header className="confirm-modal-header">
        <Modal.Title className="confirm-modal-title">
          {areYouSureTitle}
        </Modal.Title>
      </Modal.Header>
      <Modal.Footer className="confirm-modal-body">
        <Button
          variant="danger"
          className="danger-btn"
          active
          onClick={handleCancelClick}
        >
          {noTitle}
        </Button>
        <Button
          variant="success"
          className="success-btn"
          active
          onClick={handleDecisionClick}
        >
          {yesTitle}
        </Button>
        <span onClick={handleCancelClick} className="close-button">
          &times;
        </span>
      </Modal.Footer>
    </Modal>
  );
};

export const MenuModal = ({
  isMenuModalOpen,
  handleCancelClick,
  setIsYesterdayAnswerModalOpen,
  setYestBoolean,
  yestBoolean,
  setIsIntroModalOpen,
  languageString,
  setOpenFaqModal,
  setIsMenuModalOpen,
  isGenius,
  changeHeader,
  setIsTodaysExplanationForPremium,
}) => {
  const [isImageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    const image = new Image();

    image.onload = () => {
      setImageLoaded(true);
    };

    image.src = Background;
  }, []);
  return (
    <Modal
      centered
      show={isMenuModalOpen && isImageLoaded}
      onHide={handleCancelClick}
      className="menu-modal"
      loading="lazy"
    >
      <div className="text-right">
        <span onClick={handleCancelClick} className="close-button-yesterday">
          &times;
        </span>
      </div>
      <Modal.Body className="yesterday-body">
        <div className="yest-body-content">
          <Button
            onClick={() => {
              setIsYesterdayAnswerModalOpen(true);
              setYestBoolean(true);
              if (typeof setIsTodaysExplanationForPremium === "function") {
                // If already played today: show today's explanation page.
                setIsTodaysExplanationForPremium(isGenius === false && !!changeHeader);
              }
            }}
          >
            {/* {languageString.titleYesterdaysAnswer} */}
            {isGenius === true
              ? "Genius Solution"
              : changeHeader
                ? languageString.titleTodaysAnswer
                : languageString.titleYesterdaysAnswer}
          </Button>

          <Button
            onClick={() => {
              setIsIntroModalOpen(true);
            }}
          >
            {languageString.titleIntroduction}
          </Button>
          <Button
            onClick={() => {
              setOpenFaqModal(true);
            }}
          >
            {languageString.faq}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export const YesterdayAnswerModal = ({
  isYesterdayAnswerModalOpen,
  handleYesterdayAnswerClose,
  resultYesterday,
  langString,
  languageString,
  isTodaysDayRiddle,
  publisherID,
  isLoadingYesterday,
  isAlreadyAnsweredBorder,
  selectedIndicator,
  idAsNumber,
  puzzleCaseResponce,
  setDataFromChild,
  getTopic,
  setHereURL,
  forumEnabled,
  isTodaysExplanationForPremium,
  handleShareResultGoodClick,
  handleShareResultWrongClick,
  handleChallengeShareClick,
  isGenius,
  setIsCommentModalOpen,
  formattedComments,
  setFormattedComments,
  quotePrefill,
  setQuotePrefill,
}) => {
  const [finalText, setFinalText] = useState(null);

  // useEffect(() => {

  //   setFinalText(
  //     langString === "nl"
  //       ? resultYesterday.attributes?.answerExplanationNL
  //       : resultYesterday.attributes?.answerExplanation
  //   );
  // }, [isTodaysDayRiddle, publisherID, langString, resultYesterday]);

  useEffect(() => {
    const explanation =
      langString === "nl"
        ? resultYesterday.attributes?.answerExplanationNL
        : resultYesterday.attributes?.answerExplanation;

    if (!explanation) {
      setFinalText("");
      return;
    }

    // async function loadComments() {
    //     try {

    //           const Riddle = Parse.Object.extend("Riddle");
    //           const tempQuery = new Parse.Query(Riddle);
    //           tempQuery.equalTo("idNumber", idAsNumber);
    //           const results = await tempQuery.find();

    //             const object = results[0];
    //             var relation = object.get("commentRelations2");
    //             var relationQuery = relation.query();
    //              const commentsArray = await relationQuery.find();
    //               for (let i = 0; i < commentsArray.length; i++) {

    //                   var userName = commentsArray[i].get("userName");
    //                   var text =  commentsArray[i].get("text");
    //                   var profileImage =  commentsArray[i].get("profileImage");
    //                   var rating =  commentsArray[i].get("rating");

    //               }

    //     } catch (error) {
    //         console.error("Comments error:", error);
    //     }

    // };

    // loadComments();
    //console.log("loadcomment2");

    // Replace all publisher-specific blocks based on ##someID##...##someID##
    const processed = explanation.replace(
      /##(.*?)##(.*?)##\1##/gs,
      (match, id, content) => {
        return id === publisherID ? content : "";
      }
    );

    setFinalText(processed);
  }, [isTodaysDayRiddle, publisherID, langString, resultYesterday]);

  const urlify = (text) => {
    var urlRegex = /(https?:\/\/[^\s]+)/g;

    let hereString = "here";
    if (langString === "nl") {
      hereString = "hier";
    }

    //   var modifiedText = text?.replace(
    //     urlRegex,
    //     (url) => {
    //             return `<p href="${url}" class="custom-link" target="_blank">${hereString}</p>`;
    //     }

    //   );

    //   if (text?.includes("correctly")) {
    //     console.log('correctly');

    //     modifiedText = text.replace(
    //       /correctly/g,
    //       `<span class="clickable-correctly" onclick="" style="cursor: pointer; color: blue; text-decoration: underline;">correctly</span>`
    //   );

    //   }

    // return modifiedText;

    //old:
    return text?.replace(
      urlRegex,
      `<p href="$1" class="custom-link" target="_blank">${hereString}</p>`
    );
  };

  //   useEffect(() => {

  //     console.log('not prevent scrolling');
  //   window.addEventListener("wheel", (event) => event.preventDefault(), {
  //     passive: false,
  // });

  // window.addEventListener("keydown", (event) => {
  //     if (["ArrowUp", "ArrowDown", " "].includes(event.key)) {
  //        // event.preventDefault();

  //     }
  // });

  // }, []);

  const handleURLClick = (event) => {
    console.log("handleURLClick", event.target.getAttribute("href"));
    // const clickedElementText = event.target.textContent;
    // console.log('Clicked element text:', clickedElementText);

    // if (clickedElementText === 'correctly') {

    //   handleChallengeShareClick();

    // }else{

    if (publisherID === "dpg") {
      event.preventDefault();
      const clickedURL = event.target.getAttribute("href");
      PGSDK.openLink(clickedURL);
    } else {
      const clickedURL = event.target.getAttribute("href");
      setHereURL(clickedURL);
      if (clickedURL) {
        setDataFromChild(true);
      }
    }

    //  }

    // if (publisherID === "dpg") {
    //   event.preventDefault();
    //   const clickedURL = event.target.getAttribute("href");
    //   PGSDK.openLink(clickedURL);
    // }
  };

  const [scrollSize, setScrollSize] = useState(false);

  let test = document.querySelector(".yesterdayAnswer-body");
  let test2 = document.querySelector(".comments");

  const handleScroll = () => {
    let scrollBottom =
      test?.scrollHeight - test?.scrollTop - window.innerHeight + 46;
    if (scrollBottom < test2?.scrollHeight) {
      setScrollSize(true);
    } else {
      setScrollSize(false);
    }
  };
  useEffect(() => {
    handleScroll();
    test?.addEventListener("scroll", handleScroll);
    return () => {
      test?.removeEventListener("scroll", handleScroll);
    };
  }, [test]);

  return (
    <Modal
      centered
      show={isYesterdayAnswerModalOpen}
      onHide={handleYesterdayAnswerClose}
      className={`yesterdayAnswer-modal ${isLoadingYesterday ? "loading" : ""}`}
    >
      {resultYesterday && !isLoadingYesterday ? (
        <>
          <Modal.Header className="relative p-0 border-bottom-0">
            <div className="yestAnswer-title">
              <span>
                {isTodaysExplanationForPremium || isGenius === true
                  ? languageString.titleExplanation
                  : languageString.titleYesterday}

                <br />
              </span>
            </div>
            <span
              onClick={handleYesterdayAnswerClose}
              className="close-button-yesterdayansw"
            >
              &times;
            </span>
          </Modal.Header>
          <Modal.Body className="yesterdayAnswer-body">
            <div>
              <p
                className={`yesterdayAnswer-question text-center ${
                  !resultYesterday.attributes?.questionImage
                    ? "scroll-section-yesterday"
                    : ""
                }`}
              >
                {langString === "nl"
                  ? resultYesterday.attributes?.questionTextNL
                  : resultYesterday.attributes?.questionText}
              </p>
            </div>
            <div className="flex flex-col justify-center items-center mb-[20px]">
              <img
                src={
                  langString === "nl" &&
                  resultYesterday.attributes?.questionImageNL?._url
                    ? resultYesterday.attributes?.questionImageNL?._url
                    : resultYesterday.attributes?.questionImage?._url
                }
                alt=""
                style={{ maxHeight: "50vh" }}
              />
            </div>
            <div className="puzzle-body">
              <div>
                <ColoredDivider />
                <ColoredDivider />
              </div>
              {resultYesterday.attributes?.type !== "openAnswer" ? (
                <div
                  className="flex justify-evenly gap-4"
                  style={{ padding: "0 10px" }}
                >
                  {resultYesterday.attributes?.answerImage1 ? (
                    <EachDecision
                      isAlreadyAnsweredBorder={isAlreadyAnsweredBorder}
                      url={resultYesterday.attributes?.answerImage1?._url}
                      indicator="A"
                      selectedIndicator={selectedIndicator}
                      idAsNumber={idAsNumber}
                      isYesterdayAnswerModalOpen={isYesterdayAnswerModalOpen}
                    />
                  ) : null}
                  {resultYesterday.attributes?.answerImage2 ? (
                    <EachDecision
                      isAlreadyAnsweredBorder={isAlreadyAnsweredBorder}
                      url={resultYesterday.attributes?.answerImage2?._url}
                      indicator="B"
                      selectedIndicator={selectedIndicator}
                      idAsNumber={idAsNumber}
                      isYesterdayAnswerModalOpen={isYesterdayAnswerModalOpen}
                    />
                  ) : null}
                  {resultYesterday.attributes?.answerImage3 ? (
                    <EachDecision
                      isAlreadyAnsweredBorder={isAlreadyAnsweredBorder}
                      url={resultYesterday.attributes?.answerImage3?._url}
                      indicator="C"
                      selectedIndicator={selectedIndicator}
                      idAsNumber={idAsNumber}
                      isYesterdayAnswerModalOpen={isYesterdayAnswerModalOpen}
                    />
                  ) : null}
                  {resultYesterday.attributes?.answerImage4 ? (
                    <EachDecision
                      isAlreadyAnsweredBorder={isAlreadyAnsweredBorder}
                      url={resultYesterday.attributes?.answerImage4?._url}
                      indicator="D"
                      selectedIndicator={selectedIndicator}
                      idAsNumber={idAsNumber}
                      isYesterdayAnswerModalOpen={isYesterdayAnswerModalOpen}
                    />
                  ) : null}
                  {resultYesterday.attributes?.answerImage5 ? (
                    <EachDecision
                      isAlreadyAnsweredBorder={isAlreadyAnsweredBorder}
                      url={resultYesterday.attributes?.answerImage5?._url}
                      indicator="E"
                      selectedIndicator={selectedIndicator}
                      idAsNumber={idAsNumber}
                      isYesterdayAnswerModalOpen={isYesterdayAnswerModalOpen}
                    />
                  ) : null}
                  {resultYesterday.attributes?.answerImage6 ? (
                    <EachDecision
                      isAlreadyAnsweredBorder={isAlreadyAnsweredBorder}
                      url={resultYesterday.attributes?.answerImage6?._url}
                      indicator="F"
                      selectedIndicator={selectedIndicator}
                      idAsNumber={idAsNumber}
                      isYesterdayAnswerModalOpen={isYesterdayAnswerModalOpen}
                    />
                  ) : null}
                </div>
              ) : (
                <div className="flex justify-center">
                  <div className="correct-answer">{puzzleCaseResponce}</div>
                </div>
              )}

              <div>
                <p
                  className="answer-explanation-menuModal"
                  onClick={handleURLClick}
                  dangerouslySetInnerHTML={{
                    __html: urlify(finalText),
                  }}
                />
              </div>

              <div>
                <ColoredDivider />
                <ColoredDivider />
              </div>
              <DiscourseForum
                setDataFromChild={setDataFromChild}
                getTopic={getTopic}
                forumEnabled={forumEnabled}
                scrollSize={scrollSize}
                publisherID={publisherID}
                idAsNumber={idAsNumber}
                setIsCommentModalOpen={setIsCommentModalOpen}
                langString={langString}
                formattedComments={formattedComments}
                setFormattedComments={setFormattedComments}
                quotePrefill={quotePrefill}
                setQuotePrefill={setQuotePrefill}
              />
            </div>
          </Modal.Body>
        </>
      ) : (
        <div className="loader">
          <OrbitProgress
            variant="dotted"
            color="black"
            size="small"
            text=""
            textColor=""
          />
        </div>
      )}
    </Modal>
  );
};

export const WebModal = ({ setWebModalOpen, handleWebModalClose, hereURL }) => {
  // let urlToOpen;
  // if (hereURL != null) {
  //   urlToOpen = hereURL
  // }else{
  //   //kan dit weg?
  //   urlToOpen = "https://smartfriends.discourse.group/t/50";
  // }

  return (
    <Modal
      centered
      show={setWebModalOpen}
      onHide={handleWebModalClose}
      className="map-modal"
    >
      <Modal.Body className="map-body">
        <span onClick={handleWebModalClose} className="close-button-map">
          &times;
        </span>
        <iframe
          src={hereURL}
          width="100%"
          height="100%"
          name="myIframe"
          sandbox="allow-scripts allow-same-origin"
          loading="lazy"
          title="iFrame"
        ></iframe>
      </Modal.Body>
    </Modal>
  );
};

export const IntroModal = ({
  isIntroModalOpen,
  setIsIntroModalOpen,
  handleIntroModalClose,
  langString,
  setIsMenuModalOpen,
  publisherID,
  isGenius,
  tableView,
}) => {
  const [introText, setIntroText] = useState("");

  useEffect(() => {
    if (langString === "nl") {
      setIntroText(
        `Train je brein met één IQ‑challenge per dag.<br /><br />Let op: het is niet makkelijk!`
      );

      if (tableView) {
        setIntroText(
          `Klaar om zeer uitdagende genius-challenges te spelen?<br /><br />Neem je tijd, je kunt ze zo lang spelen als je wilt. Ben je er klaar voor? Genius-resultaten hebben geen invloed op je score.<br /><br />`
        );
      }

      if (publisherID === "dpg") {
        setIntroText(
          "Welkom bij SmartFriends! <br /><br />Deze nieuwe IQ-uitdaging hebben we exclusief voor abonnees gemaakt maar is tijdens de testfase voor alle spelers toegankelijk. Daarna is een abonnement op jouw favoriete nieuwsmerk genoeg om toegang te houden. Veel spelplezier!"
        );
      }
    } else {
      setIntroText(
        `Train your brain with one IQ challenge per day.<br /><br />Warning: it’s not easy!`
      );

      if (tableView) {
        setIntroText(
         // `Ready to take on more advanced genius challenges?<br /><br />Take your time; you can play them as long as you like. Give it your best shot whenever you’re ready! Genius results do not affect your score.<br /><br />`
      `Ready to take on more advanced genius challenges?<br /><br />Get smarter at your own pace and give it your best shot whenever you’re ready. No rush — you can play them for as long as you like.<br /><br />Genius results do not affect your score.<br /><br />`
        );
      }
    }
  }, [tableView]);

  useEffect(() => {
    const root = document.getElementById("root");
    const body = document.body;

    if (isIntroModalOpen) {
      root?.classList.add("fixed-root");
      // Prevent layout shift when the modal opens/closes (scrollbar compensation)
      const scrollbarWidth =
        window.innerWidth - document.documentElement.clientWidth;
      document.documentElement.style.setProperty(
        "--sf-scrollbar-width",
        `${Math.max(0, scrollbarWidth)}px`
      );
      body?.classList.add("sf-modal-open");
    } else {
      root?.classList.remove("fixed-root");
      body?.classList.remove("sf-modal-open");
    }
  }, [isIntroModalOpen]);


  return (
    <Modal
      centered
      show={isIntroModalOpen}
      onHide={handleIntroModalClose}
      className="intro-modal"
    >
      <Modal.Body className="intro-body">
        {publisherID === "dpg" && (
          <span 
            onClick={() => {
              setIsIntroModalOpen(false);
              setIsMenuModalOpen(false);
            }} 
            className="close-button-intro"
          >
            &times;
          </span>
        )}
        <div className="intro-text">
          <p dangerouslySetInnerHTML={{ __html: introText }} />
        </div>
        <div className="intro-start">
          <Button
            onClick={() => {
              setIsIntroModalOpen(false);
              setIsMenuModalOpen(false);
            }}
          >
            Start!
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export const LevelWarning = ({
  isLevelWarningModalOpen,
  langString,
  publisherID,
}) => {
  const [displayText, setDisplayText] = useState("");
  useEffect(() => {
    if (langString === "nl") {
      setDisplayText("Speel eerst alle challenges van het vorige level.");
    } else {
      setDisplayText("Please complete previous level first.");
    }

    if (
      publisherID === "usa" ||
      publisherID === "usaToday" ||
      publisherID === "wapo" ||
      publisherID === "erdee"
    ) {
      if (langString === "nl") {
        setDisplayText("Premium, alleen voor abonnees!");
      } else {
        setDisplayText("Only for premium members!");
      }
    }
  }, []);

  return (
    <Modal
      centered
      show={isLevelWarningModalOpen}
      className="LevelWarning-modal"
    >
      <Modal.Body
        className="LevelWarning-body"
        style={{
          width: "auto",
          maxWidth: "100%", // Adjust maxWidth as needed
          padding: "20px", // Add padding for better spacing
          backgroundColor: "#fdfbee",
        }}
      >
        <div className="LevelWarning-text" style={{ textAlign: "center" }}>
          <p style={{ fontFamily: "Union", fontSize: "25px", color: "black" }}>
            {displayText}
          </p>
        </div>
        <div className="LevelWarning-start">
          {/* You can add buttons or other elements here if needed */}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export const ZoomingModal = ({
  isZoomModalOpen,
  handleZoomModalClose,
  result,
  langString,
  setIsZoomCaseModal,
}) => {
  return (
    <Modal
      centered
      fullscreen={true}
      show={isZoomModalOpen}
      onHide={handleZoomModalClose}
      className="zoom-modal"
    >
      <div className="text-right">
        <span onClick={handleZoomModalClose} className="close-Zoom-btn">
          &times;
        </span>
      </div>

      <TransformWrapper>
        <TransformComponent>
          <div className="zoom-body">
            <div className="zoom-questionImage">
              <img
                src={
                  langString === "nl" &&
                  result.attributes?.questionImageNL?._url
                    ? result.attributes?.questionImageNL?._url
                    : result.attributes?.questionImage?._url
                }
                alt=""
                style={{ height: "100%" }}
              />
            </div>
            <div
              className="zoom-answerImage "
              onClick={() => setIsZoomCaseModal(true)}
            >
              {result.attributes?.answerImage1 ? (
                <img src={result.attributes?.answerImage1?._url} alt="" />
              ) : null}
              {result.attributes?.answerImage2 ? (
                <img src={result.attributes?.answerImage2?._url} alt="" />
              ) : null}
              {result.attributes?.answerImage3 ? (
                <img src={result.attributes?.answerImage3?._url} alt="" />
              ) : null}
              {result.attributes?.answerImage4 ? (
                <img src={result.attributes?.answerImage4?._url} alt="" />
              ) : null}
              {result.attributes?.answerImage5 ? (
                <img src={result.attributes?.answerImage5?._url} alt="" />
              ) : null}
            </div>
          </div>
        </TransformComponent>
      </TransformWrapper>
    </Modal>
  );
};

export const ZoomCase = ({
  isZoomCaseModal,
  setIsZoomCaseModal,
  setIsZoomModalOpen,
}) => {
  return (
    <Modal centered show={isZoomCaseModal} className="zoomCase-modal">
      <Modal.Header className="zoomCase-header">
        <span>
          Please close this zoom page <br /> to answer
        </span>
      </Modal.Header>
      <Modal.Footer className="zoomCase-footer">
        <Button
          style={{ borderBottomLeftRadius: "8px" }}
          onClick={() => setIsZoomCaseModal(false)}
        >
          Cancel
        </Button>

        <Button
          style={{ borderBottomRightRadius: "8px" }}
          onClick={() => {
            setIsZoomModalOpen(false);
            setIsZoomCaseModal(false);
          }}
        >
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
export const TypeAnswerModal = ({
  isAnswerModalOpen,
  handleTypeAnswerModalClose,
  handleDecisionClick,
  setIsAnswerInputValue,
  isAnswerInputValue,
  languageString,
}) => {
  return (
    <Modal
      centered
      show={isAnswerModalOpen}
      onHide={handleTypeAnswerModalClose}
      className="answer-modal"
    >
      <Modal.Header className="answer-header">
        <span>{languageString.typeYourAnswerTitle}</span>
      </Modal.Header>
      <Modal.Body>
        <Form.Control
          type="text"
          autoCorrect="off"
          autoComplete="off"
          //value={isAnswerInputValue}
          autoFocus
          style={{ textAlign: "center" }}
          onChange={(e) => setIsAnswerInputValue(e.target.value)}
        />
      </Modal.Body>
      <Modal.Footer className="answer-footer">
        <Button
          style={{ borderBottomLeftRadius: "8px" }}
          onClick={handleTypeAnswerModalClose}
        >
          &times;
        </Button>
        <Button
          style={{ borderBottomRightRadius: "8px" }}
          onClick={() => {
            if (isAnswerInputValue !== "") {
              handleDecisionClick();
            }
            handleTypeAnswerModalClose();
          }}
        >
          &#x2713;
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export const ScoreModal = ({
  isScoreModalOpen,
  handleScoreModalClose,
  numbersPlayed,
  won,
  streak,
  maxStreak,
  wonThisMonth,
  wonMonthDate,
  languageString,
}) => {
  const [isImageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    const image = new Image();
    image.onload = () => {
      if (isScoreModalOpen) {
        setImageLoaded(true);
      }
    };
    image.src = Background;
  }, [isScoreModalOpen]);

  return (
    <Modal
      show={isScoreModalOpen && isImageLoaded}
      onHide={handleScoreModalClose}
      centered
      className="score-modal"
      loading="lazy"
    >
      <div>
        <img
          src={Background}
          alt=""
          className="absolute"
          style={{ width: "100%", height: "100%" }}
        />
        <div className="text-right relative">
          <span className="close-button-score" onClick={handleScoreModalClose}>
            &times;
          </span>
        </div>
        <Modal.Body className="score-body">
          <div className="score-body-content">
            <div style={{ gridColumn: "1/3", lineHeight: "54px" }}>
              <span style={{ fontSize: "54px" }}>{wonThisMonth}</span>
              <span style={{ textAlign: "center", lineHeight: "24px" }}>
                {languageString.titleWonInMonth} <br />
                {wonMonthDate}
              </span>
            </div>
            <div style={{ lineHeight: "30px" }}>
              <span style={{ fontSize: "38px" }}>{numbersPlayed}</span>
              <span>{languageString.titlePlayed}</span>
            </div>
            <div style={{ lineHeight: "30px" }}>
              <span style={{ fontSize: "38px" }}>{won}</span>
              <span>{languageString.titleWon}</span>
            </div>
            <div style={{ lineHeight: "30px" }}>
              <span style={{ fontSize: "38px" }}>{streak}</span>
              <span>{languageString.titleStreak}</span>
            </div>
            <div style={{ lineHeight: "30px" }}>
              <span style={{ fontSize: "38px" }}>{maxStreak}</span>
              <span>{languageString.titleMaxStreak}</span>
            </div>
          </div>
        </Modal.Body>
      </div>
    </Modal>
  );
};
//ANSWER POP-UP
const COMPANY_LEADERBOARD_PLAYERS = [
  { name: "Emma", score: 18, photo: "https://randomuser.me/api/portraits/women/44.jpg" },
  { name: "Jij", score: 17, isYou: true, photo: defaultAvatar },
  { name: "Noah", score: 16, photo: "https://randomuser.me/api/portraits/men/11.jpg" },
  { name: "Sophie", score: 14, photo: "https://randomuser.me/api/portraits/women/68.jpg" },
  { name: "Daan", score: 13, photo: "https://randomuser.me/api/portraits/men/75.jpg" },
  { name: "Lisa", score: 12, photo: "https://randomuser.me/api/portraits/women/21.jpg" },
  { name: "Thomas", score: 11, photo: "https://randomuser.me/api/portraits/men/46.jpg" },
  { name: "Anna", score: 11, photo: "https://randomuser.me/api/portraits/women/8.jpg" },
  { name: "Lars", score: 10, photo: "https://randomuser.me/api/portraits/men/22.jpg" },
  { name: "Eva", score: 9, photo: "https://randomuser.me/api/portraits/women/57.jpg" },
  { name: "Milan", score: 8, photo: "https://randomuser.me/api/portraits/men/83.jpg" },
  { name: "Sanne", score: 8, photo: "https://randomuser.me/api/portraits/women/33.jpg" },
  { name: "Finn", score: 7, photo: "https://randomuser.me/api/portraits/men/4.jpg" },
  { name: "Iris", score: 6, photo: "https://randomuser.me/api/portraits/women/90.jpg" },
  { name: "Jesse", score: 5, photo: "https://randomuser.me/api/portraits/men/61.jpg" },
  { name: "Tess", score: 4, photo: "https://randomuser.me/api/portraits/women/17.jpg" },
  { name: "Koen", score: 3, photo: "https://randomuser.me/api/portraits/men/36.jpg" },
];

export const PuzzleCaseModal = ({
  isModalOpen,
  setIsModalOpen,
  changeHeader,
  languageString,
  isSuccess,
  result,
  isTodaysDayRiddle,
  isYesterdaysDayRiddle,
  languageDependantExplanation,
  savedTime,
  handleShareResultGoodClick,
  handleShareResultWrongClick,
  isShareModalOpen,
  setIsShareModalOpen,
  publisherID,
  langString,
  showTextCopied,
  textToShare,
  numbersPlayed,
  won,
  streak,
  maxStreak,
  wonThisMonth,
  wonMonthDate,
  isTodayModalOpen,
  isGenius,
  setIsPuzzleCaseModalClosed,
  hideButtonsBoolean,
}) => {
  const [showConfetti, setShowConfetti] = useState(true);
  const [whatDoYouThinkData, setWhatDoYouThinkData] = useState([
    {
      img: left,
      text: "too easy",
      type: "easy",
    },
    {
      img: center,
      text: "good",
      type: "good",
    },
    {
      img: right,
      text: "too hard",
      type: "hard",
    },
  ]);
  const [whatDoYouThinkDataOpen, setWhatDoYouThinkDataOpen] = useState(false);
  // const publishersWhoPostponeExplanation = [
  //   "today",
  //   "dpg",
  //   "usatoday",
  //   "tca",
  //   "aze",
  //   "erdee"
  // ];
  const oldImages = {
    easy: left,
    good: center,
    hard: right,
  };

  const newImages = {
    easy: done_left,
    good: done_center,
    hard: done_right,
  };

  let [finalText1, setFinalText1] = useState(null);
  let [rateText, setRateText] = useState(null);
  let [finalText2, setFinalText2] = useState(null);

  // const onClickwhatDoYouThink = (type) => {
  //   console.log('rating:',type)
  //   setWhatDoYouThinkDataOpen(false);

  const dropdownRef = useRef(null);

  const handleClickOutsideRating = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setWhatDoYouThinkDataOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutsideRating);

    return () => {
      document.removeEventListener("mousedown", handleClickOutsideRating);
    };
  }, []);

  const onRatingClick = (item) => {
    const updatedData = whatDoYouThinkData.map((elm) => {
      if (elm.type === item.type) {
        return {
          ...elm,

          img: newImages[item.type],
        };
      } else {
        return {
          ...elm,

          img: oldImages[elm.type],
        };
      }
      return elm;
    });

    setWhatDoYouThinkData(updatedData);
    setTimeout(() => {
      setWhatDoYouThinkDataOpen(false);
    }, 800);
  };

  useEffect(() => {
    var confettiTime = 30000;

    const timeoutId = setTimeout(() => {
      setShowConfetti(false);

      if (publisherID === "aze") {
        confettiTime = 300000000;
      }
    }, confettiTime);

    return () => clearTimeout(timeoutId);
  }, []);

  useEffect(() => {
    // if (
    //   (isTodaysDayRiddle &&
    //     publishersWhoPostponeExplanation.includes(publisherID)) ||
    //   publisherID === "today"
    // )
    if (result.attributes) {
      let answerToShow = "";
      if (result.attributes.correctOpenAnswer?.length > 0) {
        answerToShow = result.attributes.correctOpenAnswer[0];
      } else if (result.attributes?.correctAnswer) {
        answerToShow = result.attributes?.correctAnswer;
      }

      if (hideButtonsBoolean) {
        setFinalText1("");
        setFinalText2("");
        setRateText("");
      } else if (langString === "nl") {
        //numbersPlayed = 103
        var correctedNumbersPlayed = parseInt(numbersPlayed);
        if (
          correctedNumbersPlayed != 50 &&
          correctedNumbersPlayed != 100 &&
          correctedNumbersPlayed != 150 &&
          correctedNumbersPlayed != 200 &&
          correctedNumbersPlayed != 250 &&
          correctedNumbersPlayed != 300
        ) {
          while (correctedNumbersPlayed > 30) {
            const subtractValue = Math.floor(correctedNumbersPlayed / 30) * 30;
            correctedNumbersPlayed -= subtractValue;
          }
          //AVOID CORRECTING TO ANNIVERSARY
          if (
            correctedNumbersPlayed == 10 ||
            correctedNumbersPlayed == 20 ||
            correctedNumbersPlayed == 50 ||
            correctedNumbersPlayed == 100 ||
            correctedNumbersPlayed == 150 ||
            correctedNumbersPlayed == 200 ||
            correctedNumbersPlayed == 250 ||
            correctedNumbersPlayed == 300
          ) {
            correctedNumbersPlayed = correctedNumbersPlayed + 1;
          }
        }
        // console.log("correctedNumbersPlayed---",correctedNumbersPlayed)

        switch (correctedNumbersPlayed) {
          case 1:
            setFinalText1(`${answerToShow} is het goede antwoord.`);
            setFinalText2(
              `Zo meteen tonen we je de uitleg. Over ${globalCounter} staat de nieuwe challenge voor je klaar! Laat zien dat je de slimste bent! Klik op de knop rechtsboven om je score te delen.`
            );
            break;

          case 2:
            setFinalText1(`${answerToShow} is het goede antwoord.`);
            setFinalText2(
              `Over ${globalCounter} laten we zien hoe je tot dit antwoord kon komen en staat de nieuwe challenge voor je klaar! Check het menu rechtsonder. Laat zien dat je de slimste bent deze maand! Klik op de knop rechtsboven om je score te delen.`
            );
            break;

          case 3:
            setFinalText1(`${answerToShow} is het goede antwoord.`);
            setFinalText2(
              `Voel je je soms minder slim?Met SmartFriends train je verschillende delen van je hersenen. Gebieden voor logisch redeneren, ruimtelijk inzicht, verbale logica en nog veel meer. In het ene ben je goed, in het andere wat minder. Een keer verkeerd geantwoord? Geen zorgen, je kunt niet in alles goed zijn. Zolang je die grijze massa maar aan het werk zet!`
            );
            break;

          case 4:
            setFinalText1(`${answerToShow} is het goede antwoord.`);
            setFinalText2(
              `*** SmartFact ***\nWetenschappers denken dat 80% van IQ genetisch bepaald is, de rest kun je leren!`
            );
            break;

          case 5:
            setFinalText1(`${answerToShow} is het goede antwoord.`);
            setFinalText2(
              `Wil je weten hoeveel smart friends het antwoord goed hadden? Kijk in het menu bij "Uitleg van gisteren"!`
            );
            break;

          case 6:
            setFinalText1(`${answerToShow} is het goede antwoord.`);
            setFinalText2(
              `Tip! Als je de oplossing voor een uitdaging niet ziet, leg het dan opzij en probeer het later nog eens. Grote kans dat je de oplossing daarna meteen ziet.Dit fenomeen staat bekend als de incubatietijd, en het doet zich voor wanneer ons onderbewustzijn blijft werken aan een probleem, zelfs als we er niet actief aan denken. Door pauze te nemen van de challenge, laten we onze hersenen rusten en ons onderbewustzijn op de achtergrond werken. Als we later terugkeren naar de challenge, kan ons onderbewustzijn een nieuw perspectief of oplossing hebben gevonden, die ons naar het antwoord leidt.`
            );
            break;

          case 7:
            setFinalText1(`${answerToShow} is het goede antwoord.`);
            setFinalText2(
              `*** SmartFact ***\nDe afstand van alle bloedvaten in de hersenen is 4 keer zo groot als de afstand rond de wereld.`
            );
            break;

          case 8:
            setFinalText1(`${answerToShow} is het goede antwoord.`);
            setFinalText2(
              `Wil je weten hoeveel smart friends het antwoord goed hadden? Kijk in het menu bij "Uitleg van gisteren"!`
            );
            break;

          case 9:
            setFinalText1(`${answerToShow} is het goede antwoord.`);
            setFinalText2(
              `*** SmartFact ***\nElke dag IQ challenges spelen houdt je hersenen jong!`
            );
            break;

          //case 10: anniversary

          case 11:
            setFinalText1(`${answerToShow} is het goede antwoord.`);
            setFinalText2(
              `*** SmartFact ***Grootte doet er niet toe in de hersenen. Er is geen bewijs dat grotere hersenen slimmer zijn dan kleinere.`
            );
            break;

          case 12:
            setFinalText1(`${answerToShow} is het goede antwoord.`);
            setFinalText2(
              `*** SmartFact ***\nHet grootste brein van alle dieren is dat van de potvis. Het weegt ongeveer 9 KG.`
            );
            break;

          case 13:
            setFinalText1(`${answerToShow} is het goede antwoord.`);
            setFinalText2(
              `*** SmartFact ***\nHet menselijk brein wordt in het eerste levensjaar drie keer zo groot.`
            );
            break;

          case 14:
            setFinalText1(`${answerToShow} is het goede antwoord.`);
            setFinalText2(
              `Brainfood tip! Pure chocolade is goed voor de hersenen. Het bevat flavonoïden die de bloedtoevoer naar de hersenen en daarmee de cognitieve functie kunnen verbeteren.`
            );
            break;

          case 15:
            setFinalText1(`${answerToShow} is het goede antwoord.`);
            setFinalText2(
              `*** SmartFact ***\nHet idee dat linkshandigen slimmer zijn dan rechtshandigen is onzin.`
            );
            break;

          case 16:
            setFinalText1(`${answerToShow} is het goede antwoord.`);
            setFinalText2(
              `*** SmartFact ***\nWilliam Sidis, geboren in 1898, was de intelligentste man in de geschiedenis. Zijn IQ werd geschat tussen 250 en 300.`
            );
            break;

          case 17:
            setFinalText1(`${answerToShow} is het goede antwoord.`);
            setFinalText2(
              `*** SmartFact ***\nGroot hoofd, grote hersenen? Mogelijk, maar wetenschappers weten niet zeker of dit het IQ beïnvloedt.`
            );
            break;

          case 18:
            setFinalText1(`${answerToShow} is het goede antwoord.`);
            setFinalText2(
              `*** SmartFact ***\nBen je een genie? Scores van 160 of meer worden erkend als geniaal niveau.`
            );
            break;

          case 19:
            setFinalText1(`${answerToShow} is het goede antwoord.`);
            setFinalText2(
              `*** SmartFact ***\nIntelligentie is niet iets dat vaststaat. Blijf jezelf pushen om nieuwe dingen te leren en jezelf uit te dagen, je zult versteld staan van wat je allemaal kunt bereiken.`
            );
            break;

          case 21:
            setFinalText1(`${answerToShow} is het goede antwoord.`);
            setFinalText2(
              `*** SmartFact ***\nDe hersenen kunnen geen pijn voelen. Het interpreteert pijnsignalen die naar het brein worden gestuurd, maar het voelt geen pijn.`
            );
            break;

          case 22:
            setFinalText1(`${answerToShow} is het goede antwoord.`);
            setFinalText2(
              `*** SmartFact ***\nEr zijn aanwijzingen dat kauwgom een positieve invloed kan hebben op bepaalde aspecten van de cognitieve functie, zoals aandacht, geheugen en reactietijd. Bovendien kan het kauwen zelf helpen om stress te verminderen en alertheid te verhogen, wat ook een positief effect kan hebben op de cognitieve functie.`
            );
            break;

          case 23:
            setFinalText1(`${answerToShow} is het goede antwoord.`);
            setFinalText2(
              `*** SmartFact ***\nUitdroging vermindert de intellectuele capaciteit.`
            );
            break;

          case 24:
            setFinalText1(`${answerToShow} is het goede antwoord.`);
            setFinalText2(
              `*** SmartFact ***\nHet oplossen van IQ challenge kan helpen bij het ontwikkelen van kritisch denkvermogen, dat essentieel is voor succes in verschillende academische en professionele bezigheden. Blijf SmartFriends dagelijks gebruiken!`
            );
            break;

          case 25:
            setFinalText1(`${answerToShow} is het goede antwoord.`);
            setFinalText2(
              `*** SmartFact ***\nHet is wetenschappelijk bewezen dat het menselijk brein tegen het einde van de 20 begint te lijden onder geheugenverlies..`
            );
            break;

          case 26:
            setFinalText1(`${answerToShow} is het goede antwoord.`);
            setFinalText2(
              `*** SmartFact ***\nVolgens The New England Journal of Medicine hadden volwassenen die deelnamen aan hersenuitdagende activiteiten 63 procent minder kans om dementie te ontwikkelen.`
            );
            break;

          case 27:
            setFinalText1(`${answerToShow} is het goede antwoord.`);
            setFinalText2(
              `*** SmartFact ***\nCognitief denken kan verbeterd worden door verschillende technieken, zoals hersentrainingsoefeningen, nieuwe vaardigheden leren, stress verminderen, voldoende slaap en gezonde voeding. Door je cognitieve denkvermogen kun je je probleemoplossend vermogen, creativiteit en besluitvaardigheid verbeteren.`
            );
            break;

          case 28:
            setFinalText1(`${answerToShow} is het goede antwoord.`);
            setFinalText2(
              `*** SmartFact ***\nHet menselijk brein wordt kleiner naarmate we ouder worden.`
            );
            break;

          case 29:
            setFinalText1(`${answerToShow} is het goede antwoord.`);
            setFinalText2(
              `*** SmartFact ***\nFouten maken is een natuurlijk onderdeel van het leerproces. Door onze fouten groeien we en verbeteren we onszelf. Laat je dus niet demotiveren door een fout antwoord. Gebruik het als een kans om te identificeren op welke gebied je je denken kunt verbeteren.`
            );
            break;

          case 30:
            setFinalText1(`${answerToShow} is het goede antwoord.`);
            setFinalText2(
              ` Tip! Voldoende slaap is essentieel voor de cognitieve functie en het geheugen. Slaapgebrek kan de cognitieve functie aantasten en de geheugenprestaties verminderen.`
            );
            break;

          //ANNIVERSARIES
          case 10:
            setFinalText1(`${answerToShow} is het goede antwoord.`);
            setFinalText2(
              `Vandaag voor de 10de keer gespeeld, goed gedaan!Deel het met je vrienden en daag ze uit!`
            );
            break;

          case 20:
            setFinalText1(`${answerToShow} is het goede antwoord.`);
            setFinalText2(`Vandaag voor de 20ste keer gespeeld, goed gedaan!`);
            break;

          case 50:
            setFinalText1(`${answerToShow} is het goede antwoord.`);
            setFinalText2(`Vandaag voor de 50ste keer gespeeld, goed gedaan!`);
            break;

          case 100:
            setFinalText1(`${answerToShow} is het goede antwoord.`);
            setFinalText2(`Vandaag voor de 100ste keer gespeeld, goed gedaan!`);
            break;

          case 150:
            setFinalText1(`${answerToShow} is het goede antwoord.`);
            setFinalText2(`Vandaag voor de 150ste keer gespeeld, goed gedaan!`);
            break;

          case 200:
            setFinalText1(`${answerToShow} is het goede antwoord.`);
            setFinalText2(`Vandaag voor de 200ste keer gespeeld, goed gedaan!`);
            break;

          case 250:
            setFinalText1(`${answerToShow} is het goede antwoord.`);
            setFinalText2(`Vandaag voor de 250ste keer gespeeld, goed gedaan!`);
            break;

          case 300:
            setFinalText1(`${answerToShow} is het goede antwoord.`);
            setFinalText2(`Vandaag voor de 300ste keer gespeeld, goed gedaan!`);
            break;

          default:
            setFinalText1(`${answerToShow} is het goede antwoord.`);
            setFinalText2(
              `Zo meteen tonen we je de uitleg. Over ${globalCounter} staat de nieuwe challenge voor je klaar! Laat zien dat je de slimste bent! Klik op de knop rechtsboven om je score te delen.`
            );

            break;
        }

        if (isGenius) {
          setFinalText1(`${answerToShow} is het goede antwoord!`);

          setFinalText2(
            `Genius challenges kunnen moeilijk zijn, maar je bent op de goede weg! We zullen de uitleg kort weergeven.\nVoel je je minder slim?\n\nMet SmartFriends train je veel verschillende gebieden van je hersenen. Gebieden voor logisch redeneren, ruimtelijk inzicht, verbale logica en nog veel meer. \In het ene ben je goed, in het andere minder. Verkeerd antwoord? Maak je geen zorgen, je kunt niet overal goed in zijn. Zolang je die grijze massa maar aan het werk zet!`
          );
        }

        if (!rateText) {
          // setRateText(`Te makkelijk, goed of te moeilijk? Rate deze challenge!`);
          setRateText(``);
        }

        /*  
----MOTIVATIONS NEDERLANDS----
      
----- Intelligentie is niet iets dat vaststaat. Blijf jezelf pushen om nieuwe dingen te leren en jezelf uit te dagen, je zult versteld staan van wat je allemaal kunt bereiken.


----- Het oplossen van IQ challenge kan helpen bij het ontwikkelen van kritisch denkvermogen, dat essentieel is voor succes in verschillende academische en professionele bezigheden. Blijf SmartFriends dagelijks gebruiken!


------ Hersenvoeding tip! Pure chocolade is goed voor de hersenen. Het bevat flavonoïden die de bloedtoevoer naar de hersenen en daarmee de cognitieve functie kunnen verbeteren.


------ Fouten maken is een natuurlijk onderdeel van het leerproces. Door onze fouten groeien we en verbeteren we onszelf. Laat je dus niet demotiveren door een fout antwoord. Gebruik het als een kans om te identificeren op welke gebied je je denken kunt verbeteren.


-----Tip! Voldoende slaap is essentieel voor de cognitieve functie en het geheugen. Slaapgebrek kan de cognitieve functie aantasten en de geheugenprestaties verminderen.


---- Er zijn aanwijzingen dat kauwgom een positieve invloed kan hebben op bepaalde aspecten van de cognitieve functie, zoals aandacht, geheugen en reactietijd.
Bovendien kan het kauwen zelf helpen om stress te verminderen en alertheid te verhogen, wat ook een positief effect kan hebben op de cognitieve functie.


----- Tip! Als je de oplossing voor een uitdaging niet ziet, leg het dan opzij en probeer het later nog eens. Grote kans dat je de oplossing daarna meteen ziet.
Dit fenomeen staat bekend als de incubatietijd, en het doet zich voor wanneer ons onderbewustzijn blijft werken aan een probleem, zelfs als we er niet actief aan denken. Door 
pauze te nemen van de challenge, laten we onze hersenen rusten en ons onderbewustzijn op de achtergrond werken. Als we later terugkeren naar de challenge, kan ons onderbewustzijn 
een nieuw perspectief of oplossing hebben gevonden, die ons naar het antwoord leidt.


----- Cognitief denken kan verbeterd worden door verschillende technieken, 
zoals hersentrainingsoefeningen, nieuwe vaardigheden leren, stress verminderen, 
voldoende slaap en gezonde voeding. Door je cognitieve denkvermogen kun je je probleemoplossend vermogen, creativiteit en besluitvaardigheid verbeteren.




----MOTIVATIONS ENGLISH----
Your correct answer demonstrates your excellent problem-solving 
skills and sharp intellect. Continue to solve challenges like these, they help to
challenge and stimulate the brain, improving cognitive function and overall mental performance.    
        
        
Remember that intelligence is not fixed, 
and with dedication and hard work, you can continue 
to develop and expand your knowledge and skills. 

Keep pushing yourself to learn new things and challenge yourself, 
and you'll be amazed at what you're capable of achieving.


Solving IQ challenges can help to develop critical thinking skills,
which are essential for success in various academic and professional pursuits. %Keep up the excellent work!%


Brain food tip!
Dark Chocolate is good for the brain. It contains flavonoids 
that can improve blood flow to the brain and improve cognitive function.

Making mistakes is a natural part of the learning process, 
and it's through our mistakes that we grow and improve. 
So don't let one wrong answer bring you down. Use it as a learning 
opportunity and a chance to identify areas where you can improve.


Just a small tip: getting enough 
sleep is essential for cognitive function and memory. 
Lack of sleep can impair cognitive function and reduce memory performance.


There is some evidence to suggest that chewing gum can have a positive impact on certain aspects of cognitive function, 
such as attention, memory, and reaction time.

Chewing gum can increase blood flow to the brain,
which may help to improve cognitive performance. Additionally, 
the act of chewing itself may help to reduce stress and increase alertness, 
which can also have a positive effect on cognitive function.


If don't see the solution to a challenge, put it aside and try again later. Big change that you will the the solution instantly.

This phenomenon is known as the %incubation period%,
and it occurs when our subconscious mind continues to work on 
a problem even when we are not actively thinking about it. By taking 
a break from the challenge, we allow our brain to rest and let our subconscious 
work in the background. When we return to the challenge later, our subconscious 
may have found a new perspective or solution to the problem, leading us to the answer
we were struggling to find before. Additionally, taking a break can help us approach 
the challenge with a fresh perspective, which may also aid in finding the solution.


Making mistakes is an inevitable part of learning and growing. 
Instead, use this experience as an opportunity to learn and improve. 
Identifying the mistake you made, increase chances of getting similar challenges right in the future. 
Keep your head up, stay motivated,
and use this setback as fuel to propel you towards even greater accomplishments.


Cognitive thinking can be improved through various techniques, 
such as brain training exercises, learning new skills, reducing stress, 
getting enough sleep, and adopting a healthy diet. By improving cognitive 
thinking skills, you can enhance your problem-solving abilities, creativity, a
nd decision-making skills. This can benefit them in various aspects of life, 
including academic and professional pursuits.


Don't let a wrong answer discourage you!

Remember that the IQ challenges don't define 
your worth or potential. Keep pushing yourself and striving towards 
your goals, and you'll be amazed at what you can achieve.
*/

        /*    
----ONELINERS NEDERLANDS----
Voel je je al slimmer?
Elke dag IQ uitdagingen spelen houdt je hersenen jong!

Weer terug? Je wordt er echt goed in!
Wetenschappers denken dat 80% van IQ genetisch bepaald is, de rest kun je leren!
Elke keer dat je een herinnering ophaalt, creëer je een verbinding in de hersenen.
Grootte doet er niet toe in de hersenen. Er is geen bewijs dat grotere hersenen slimmer zijn dan kleinere.
Het grootste brein van alle dieren is dat van de potvis. Het weegt ongeveer 9 KG.
Het menselijk brein wordt in het eerste levensjaar drie keer zo groot.
Het idee dat linkshandigen slimmer zijn dan rechtshandigen is onzin.
William Sidis, geboren in 1898, was de intelligentste man in de geschiedenis. Zijn IQ werd geschat tussen 250 en 300.
Groot hoofd, grote hersenen? Mogelijk, maar wetenschappers weten niet zeker of dit het IQ beïnvloedt.
Ben je een genie? Scores van 160 of meer worden erkend als geniaal niveau.

Vandaag voor de 50e keer gespeeld, goed gedaan!

De hersenen kunnen geen pijn voelen. Het interpreteert pijnsignalen die naar het brein worden gestuurd, maar het voelt geen pijn.

Uitdroging vermindert de intellectuele capaciteit.

Het is wetenschappelijk bewezen dat het menselijk brein tegen het einde van de 20 begint te lijden onder geheugenverlies.
Volgens The New England Journal of Medicine hadden volwassenen die deelnamen aan hersenuitdagende activiteiten 63 procent minder kans om dementie te ontwikkelen.
Het menselijk brein wordt kleiner naarmate we ouder worden.
Tekenen van een succesvolle beha



------ONELINERS ENGLISH-----
Feeling smarter already?
Playing IQ challenges every day keeps your brain young!

Back again? You're getting really good at it!
Scientists think 80% of IQ is genetic, the rest can be learned!
Every time you recall a memory, you create a connection in the brain.
Size doesn’t matter in the brain. There is no evidence that a larger brain is smarter than a smaller brain.
The largest brain of any animal is that of the sperm whale. It weighs about 20 pounds (9 KG).
The human brain will grow three times its size in the first year of life.
The notion that left-handed people are smarter than right-handed people is nonsense.
William Sidis, born in 1898, was the most intelligent man in history. His IQ was estimated at between 250 and 300.
Big head, big brain? Possibly, but scientists aren't sure if this affects the IQ.
Are you a genius? Scores of 160 or over are recognized as genius level.

Playing for the 50th time today, well done!

The brain can’t feel pain. It interprets pain signals sent to it, but it does not feel pain.
The largest brain of any animal is that of the sperm whale. It weighs about 20 pounds (9 KG).
Dehydration reduces intellectual capacity.

It has been scientifically proven that the human brain begins to lose some memory abilities by your late 20's.
According The New England Journal of Medicine, adults who participated in mind-challenging activities were 63 percent less likely to develop dementia.
The human brain gets smaller as we get older.
Signs of successful brain surgeries go as far back as the Stone Age.
75% of the brain is made up of water. Dehydration can have a negative effect on the brain functions.
Children whose parents talk to them, read to them and provide them with music tend to be more intelligent.
Your brain uses 20 percent of the oxygen and blood in your body.

In the last 100 years the IQ of women grew faster than that of men.

The distance of all blood vessels in the brain is 4 times greater than the distance around the world.

Terrence Tao has an IQ of 230. This makes him the most intelligent man of the world.

*/
      } else {
        // numbersPlayed = 220
        var correctedNumbersPlayed = parseInt(numbersPlayed);
        if (
          correctedNumbersPlayed != 50 &&
          correctedNumbersPlayed != 100 &&
          correctedNumbersPlayed != 150 &&
          correctedNumbersPlayed != 200 &&
          correctedNumbersPlayed != 250 &&
          correctedNumbersPlayed != 300
        ) {
          while (correctedNumbersPlayed > 50) {
            const subtractValue = Math.floor(correctedNumbersPlayed / 50) * 50;
            correctedNumbersPlayed -= subtractValue;
          }

          //AVOID CORRECTING TO ANNIVERSARY
          if (
            correctedNumbersPlayed == 10 ||
            correctedNumbersPlayed == 20 ||
            correctedNumbersPlayed == 50 ||
            correctedNumbersPlayed == 100 ||
            correctedNumbersPlayed == 150 ||
            correctedNumbersPlayed == 200 ||
            correctedNumbersPlayed == 250 ||
            correctedNumbersPlayed == 300
          ) {
            correctedNumbersPlayed = correctedNumbersPlayed + 1;
          }
        }

        // if (publisherID === 'usaPremium') {
        //   isPremium = true
        // }

        switch (correctedNumbersPlayed) {
          case 1:
            setFinalText1(`${answerToShow} is the correct answer!`);
            setFinalText2(
              `We’ll show you our explanation shortly. In ${globalCounter}, a new challenge awaits! Show off your brilliance this month by clicking the button in the top-right corner to share your score.\n\nSee you tomorrow! Reminder: SmartFriends is challenging—and definitely not easy.`
            );
            break;

          case 2:
            setFinalText1(`${answerToShow} is the correct answer!`);
            setFinalText2(
              `Feeling less smart?\nWith SmartFriends, you’re training multiple areas of your brain: logical reasoning, spatial awareness, verbal logic, and more. It’s completely normal to excel in some areas and find others more challenging. Got a wrong answer? No worries—you can’t be great at everything! What matters is keeping that gray matter active and thriving!`
            );
            break;

          case 3:
            setFinalText1(`${answerToShow} is the correct answer!`);
            setFinalText2(
              `We’ll show you our explanation shortly. In ${globalCounter}, a new challenge awaits! Show off your brilliance this month by clicking the button in the top-right corner to share your score.\n\nSee you tomorrow! Reminder: SmartFriends is challenging—and definitely not easy.`
            );
            break;

          case 4:
            setFinalText1(`${answerToShow} is the correct answer!`);
            setFinalText2(
              `*** SmartFact ***\nScientists believe 80% of IQ is genetic, but the rest can be developed through learning!`
            );
            break;

          case 5:
            setFinalText1(`${answerToShow} is the correct answer!`);
            setFinalText2(
              `Curious to know how many SmartFriends answered correctly? Check out "Yesterday's Answer" in the menu!`
            );
            break;

          case 6:
            setFinalText1(`${answerToShow} is the correct answer!`);
            setFinalText2(
              `*** SmartFact ***\nThe total length of blood vessels in the brain is four times the circumference of the Earth!`
            );
            break;

          case 7:
            setFinalText1(`${answerToShow} is the correct answer!`);
            setFinalText2(
              `*** SmartFact ***\nEngaging with daily IQ challenges helps keep your brain sharp and youthful!`
            );
            break;

          case 8:
            setFinalText1(`${answerToShow} is the correct answer!`);
            setFinalText2(
              `Curious to know how many SmartFriends answered correctly? Check out "Yesterday's Answer" in the menu!`
            );
            break;

          case 9:
            setFinalText1(`${answerToShow} is the correct answer!`);
            setFinalText2(
              `Tip! If you don’t see the solution to a challenge, put it aside and try again later. There’s a good chance you’ll find the solution instantly.\n\nThis phenomenon, called the "incubation period," happens when your subconscious mind keeps working on a problem even when you’re not actively thinking about it. Taking a break gives your brain time to rest and process in the background. When you return, you might see the problem from a fresh perspective and quickly discover the solution!`
            );

          //case 10: anniversary

          case 11:
            setFinalText1(`${answerToShow} is the correct answer!`);
            setFinalText2(
              `*** SmartFact ***\nBrain size doesn't determine intelligence. No scientific evidence suggests that a larger brain is more intelligent than a smaller one.`
            );
            break;

          case 12:
            setFinalText1(`${answerToShow} is the correct answer!`);
            setFinalText2(
              `*** SmartFact ***\nThe sperm whale has the largest brain of any animal, weighing about 20 pounds.`
            );
            break;

          case 13:
            setFinalText1(`${answerToShow} is the correct answer!`);
            setFinalText2(
              `*** SmartFact ***\nIn the first year of life, the human brain grows to three times its original size.`
            );
            break;

          case 14:
            setFinalText1(`${answerToShow} is the correct answer!`);
            setFinalText2(
              `Brain food tip! Dark chocolate is beneficial for the brain. It contains flavonoids that enhance blood flow to the brain and improve cognitive function.`
            );
            break;

          case 15:
            setFinalText1(`${answerToShow} is the correct answer!`);
            setFinalText2(
              `*** SmartFact ***\nThe idea that left-handed people are smarter than right-handed people is simply a myth.`
            );
            break;

          case 16:
            setFinalText1(`${answerToShow} is the correct answer!`);
            setFinalText2(
              `*** SmartFact ***\n The human brain is about 2% of your body weight, but it uses around 20% of your energy.`
            );
            break;

          case 17:
            setFinalText1(`${answerToShow} is the correct answer!`);
            setFinalText2(
              `*** SmartFact ***\nBig head, big brain? Maybe, but scientists aren't certain whether this directly affects IQ.`
            );
            break;

          case 18:
            setFinalText1(`${answerToShow} is the correct answer!`);
            setFinalText2(
              `*** SmartFact ***\nWilliam Sidis, born in 1898, is considered one of the most intelligent people in history, with an estimated IQ between 250 and 300.`
            );
            break;

          case 19:
            setFinalText1(`${answerToShow} is the correct answer!`);
            setFinalText2(
              `*** SmartFact ***\nIntelligence isn’t fixed! With dedication and effort, you can keep developing your knowledge and skills.`
            );
            break;

          case 21:
            setFinalText1(`${answerToShow} is the correct answer!`);
            setFinalText2(
              `*** SmartFact ***\nThe brain doesn’t feel pain. It processes pain signals, but it doesn't experience pain itself.`
            );
            break;

          case 22:
            setFinalText1(`${answerToShow} is the correct answer!`);
            setFinalText2(
              `*** SmartFact ***\nChewing gum may positively affect cognitive functions, including attention, memory, and reaction time, according to some evidence.`
            );
            break;

          case 23:
            setFinalText1(`${answerToShow} is the correct answer!`);
            setFinalText2(
              `*** SmartFact ***\nDehydration can impair cognitive abilities and reduce intellectual performance.`
            );
            break;

          case 24:
            setFinalText1(`${answerToShow} is the correct answer!`);
            setFinalText2(
              `*** SmartFact ***\nWorking on IQ challenges develops critical thinking skills, essential for academic and professional success. Great job, and keep it up!`
            );
            break;

          case 25:
            setFinalText1(`${answerToShow} is the correct answer!`);
            setFinalText2(
              `*** SmartFact ***\nResearch shows that the brain begins to experience some memory decline by the late 20s.`
            );
            break;

          case 26:
            setFinalText1(`${answerToShow} is the correct answer!`);
            setFinalText2(
              `*** SmartFact ***\nAccording to The New England Journal of Medicine, adults who engaged in mentally stimulating activities were 63% less likely to develop dementia.`
            );
            break;

          case 27:
            setFinalText1(`${answerToShow} is the correct answer!`);
            setFinalText2(
              `*** SmartFact ***\nEnhance cognitive skills with brain training, learning new skills, reducing stress, sleeping well, and eating healthily. These improvements boost problem-solving, creativity, and decision-making for academic and professional success.`
            );
            break;

          case 28:
            setFinalText1(`${answerToShow} is the correct answer!`);
            setFinalText2(
              `*** SmartFact ***\nThe human brain naturally shrinks in size as we age.`
            );
            break;

          case 29:
            setFinalText1(`${answerToShow} is the correct answer!`);
            setFinalText2(
              `*** SmartFact ***\nMistakes are a vital part of learning. Embrace them as opportunities to grow, improve, and identify areas for development.`
            );
            break;

          case 30:
            setFinalText1(`${answerToShow} is the correct answer!`);
            setFinalText2(
              `Tip! Sleep is critical for memory and cognitive function. Insufficient sleep can negatively impact both.`
            );
            break;

          case 31:
            setFinalText1(`${answerToShow} is the correct answer!`);
            setFinalText2(
              `*** SmartFact ***\nDo you qualify as a genius? IQ scores of 160 or higher are considered genius-level`
            );
            break;
          case 32:
            setFinalText1(`${answerToShow} is the correct answer!`);
            setFinalText2(
              `*** SmartFact ***\nYour brain has more connections (synapses) than there are stars in the Milky Way.`
            );
            break;
          case 33:
            setFinalText1(`${answerToShow} is the correct answer!`);
            setFinalText2(
              `*** SmartFact ***\nMost people can hold 5 to 9 items in their short-term memory.`
            );
            break;
          case 34:
            setFinalText1(`${answerToShow} is the correct answer!`);
            setFinalText2(
              `*** SmartFact ***\nThe brain never stops growing and adapting. Even in old age, new connections can be formed.`
            );
            break;
          case 35:
            setFinalText1(`${answerToShow} is the correct answer!`);
            setFinalText2(
              `*** SmartFact ***\nSmarter people’s brains tend to work more efficiently and use less energy during problem-solving.`
            );
            break;
          case 36:
            setFinalText1(`${answerToShow} is the correct answer!`);
            setFinalText2(
              `*** SmartFact ***\nYour brain produces enough electricity to power a small LED light bulb.`
            );
            break;
          case 37:
            setFinalText1(`${answerToShow} is the correct answer!`);
            setFinalText2(
              `*** SmartFact ***\nPhysical exercise can improve your intelligence by boosting blood flow to the brain.`
            );
            break;
          case 38:
            setFinalText1(`${answerToShow} is the correct answer!`);
            setFinalText2(
              `*** SmartFact ***\nDaydreaming activates your brain’s “default mode network,” which is linked to creativity.`
            );
            break;
          case 39:
            setFinalText1(`${answerToShow} is the correct answer!`);
            setFinalText2(
              `*** SmartFact ***\nLearning something new strengthens existing connections and creates new ones in your brain.`
            );
            break;
          case 40:
            setFinalText1(`${answerToShow} is the correct answer!`);
            setFinalText2(
              `*** SmartFact ***\nYour brain uses about 12 watts of power, less than a household light bulb.`
            );
            break;
          case 41:
            setFinalText1(`${answerToShow} is the correct answer!`);
            setFinalText2(
              `*** SmartFact ***\nThe average human brain has about 86 billion neurons, which transmit information across your nervous system.`
            );
            break;
          case 42:
            setFinalText1(`${answerToShow} is the correct answer!`);
            setFinalText2(
              `*** SmartFact ***\nYour brain processes information at an estimated speed of 60 bits per second—faster than the fastest supercomputers.`
            );
            break;
          case 43:
            setFinalText1(`${answerToShow} is the correct answer!`);
            setFinalText2(
              `*** SmartFact ***\nThe left side of your brain is more involved in logical reasoning, while the right side is more connected to creativity.`
            );
            break;
          case 44:
            setFinalText1(`${answerToShow} is the correct answer!`);
            setFinalText2(
              `*** SmartFact ***\nMultitasking is actually a myth—your brain rapidly switches between tasks instead of focusing on multiple at once.`
            );
            break;
          case 45:
            setFinalText1(`${answerToShow} is the correct answer!`);
            setFinalText2(
              `*** SmartFact ***\nReading aloud to children helps develop both their linguistic and cognitive skills faster.`
            );
            break;
          case 46:
            setFinalText1(`${answerToShow} is the correct answer!`);
            setFinalText2(
              `*** SmartFact ***\nYou can improve your memory and cognitive abilities by learning a new language or playing a musical instrument.`
            );
            break;
          case 47:
            setFinalText1(`${answerToShow} is the correct answer!`);
            setFinalText2(
              `*** SmartFact ***\nThe brain has a “glymphatic system” that clears toxins during sleep, making rest essential for mental health.`
            );
            break;
          case 48:
            setFinalText1(`${answerToShow} is the correct answer!`);
            setFinalText2(
              `*** SmartFact ***\nMeditation has been shown to increase gray matter density in the brain, enhancing focus and emotional regulation.`
            );
            break;
          case 49:
            setFinalText1(`${answerToShow} is the correct answer!`);
            setFinalText2(
              `*** SmartFact ***\nThe brain processes visual information in just 13 milliseconds—faster than the blink of an eye.`
            );
            break;
          case 50:
            setFinalText1(`${answerToShow} is the correct answer!`);
            setFinalText2(
              `*** SmartFact ***\nContrary to popular belief, humans use far more than 10% of their brains. Nearly all regions are active at different times, even during rest.`
            );
            break;

          //ANNIVERSARIES
          case 10:
            setFinalText1(`${answerToShow} is the correct answer!`);
            setFinalText2(
              `Played for the 10th time today. Way to go! Spread the fun—challenge your friends to join in!`
            );
            break;

          case 20:
            setFinalText1(`${answerToShow} is the correct answer!`);
            setFinalText2(
              `Wow, 20 plays today! You're on fire! Keep that streak alive!`
            );
            break;

          case 50:
            setFinalText1(`${answerToShow} is the correct answer!`);
            setFinalText2(
              `Incredible! Played for the 50th time today. You're unstoppable!`
            );
            break;

          case 100:
            setFinalText1(`${answerToShow} is the correct answer!`);
            setFinalText2(
              `100 plays? You're officially a brain-training superhero! Keep it up!`
            );
            break;

          case 150:
            setFinalText1(`${answerToShow} is the correct answer!`);
            setFinalText2(
              `Centurion alert! 150 plays—you're an absolute legend!`
            );
            break;

          case 200:
            setFinalText1(`${answerToShow} is the correct answer!`);
            setFinalText2(
              `200 plays? That’s epic! Your dedication is next level!`
            );
            break;

          case 250:
            setFinalText1(`${answerToShow} is the correct answer!`);
            setFinalText2(
              `Quarter-thousand plays! You're rewriting the rulebook of persistence!`
            );
            break;

          case 300:
            setFinalText1(`${answerToShow} is the correct answer!`);
            setFinalText2(
              `300 plays? Mind blown! You're the definition of unstoppable!`
            );
            break;

          default:
            setFinalText1(`${answerToShow} is the correct answer!`);
            setFinalText2(
              `We’ll show you our explanation shortly. In ${globalCounter}, a new challenge awaits! Show off your brilliance this month by clicking the button in the top-right corner to share your score.\n\nSee you tomorrow! Reminder: SmartFriends is challenging—and definitely not easy.`
            );

            break;
        }
        if (isGenius) {
          if (isSuccess) {
            setFinalText1(`${answerToShow} is the correct answer.`);

            setFinalText2(
              `You must be a real genius! Keep up the great work—we’ll show you our explanation shortly.\n\nNot feeling as sharp sometimes? No worries! With SmartFriends, you’re training various areas of your brain, like logical reasoning, spatial awareness, verbal logic, and more. You might excel in some areas while finding others more challenging. If you get an answer wrong, don’t sweat it—you’re not supposed to be perfect at everything. Just keep that gray matter active and thriving!`
            );
          } else {
            setFinalText1(`${answerToShow} is the correct answer...`);

            setFinalText2(
              `Genius challenges can be really tough, but you're making amazing progress! We’ll show the explanation shortly.\n\nNot feeling as sharp sometimes?\nWith SmartFriends, you're training multiple areas of your brain, like logical reasoning, spatial awareness, verbal logic, and more. It’s normal to excel in some areas and find others more challenging. Got a wrong answer? No worries—you can’t be perfect at everything. Just keep that gray matter active and growing!`
            );
          }
        }

        if (!rateText) {
          //setRateText(`Too easy, good or too hard? Rate this challenge!`);
          setRateText("");
        }
      }
    }
  }, [
    isTodaysDayRiddle,
    publisherID,
    langString,
    result,
    numbersPlayed,
    globalCounter,
    hideButtonsBoolean,
  ]);

  const urlify = (text) => {
    var urlRegex = /(https?:\/\/[^\s]+)/g;

    return text?.replace(
      urlRegex,
      '<a href="#" class="custom-link" target="_blank">here</a>'
    );
  };

  return (
    <>
      <Modal
        show={isModalOpen}
        onHide={() => {
          isTodayModalOpen(false);
          setTimeout(() => {
            setWhatDoYouThinkDataOpen(false);
            setIsPuzzleCaseModalClosed(true)
          }, 500);
        }}
        className={`puzzle-case${hideButtonsBoolean ? " hide-buttons-modal" : ""}`}
      >
        {changeHeader && !hideButtonsBoolean ? (
          <Modal.Header className="puzzle-case-header flex items-center">
            <Modal.Title className="flex items-start h-100 flex-column">
              <p className="puzzle-case-header-title text-center">
                {languageString.alreadyPlayedTitle}
              </p>

              {!isYesterdaysDayRiddle ? (
                <div>
                  <p className="puzzle-case-header-title text-start"></p>
                  <div></div>
                </div>
              ) : null}
            </Modal.Title>
            <Modal.Title>
              {showTextCopied ? (
                <p className="puzzle-case-header-title text-center">Copied</p>
              ) : (
                <>
                  {!hideButtonsBoolean &&
                    (savedTime &&
                    savedTime?.selectedValue?.toLowerCase() ===
                      window.correctAnswer.toLowerCase() ? (
                      <button
                        onClick={() => {
                          handleShareResultGoodClick();
                        }}
                        style={{
                          height: "40px",
                          width: "40px",
                          borderRadius: "7px",
                        }}
                      >
                        <svg
                          xmlns="https://www.w3.org/2000/svg"
                          width="25"
                          height="25"
                          fill="#fdfbee"
                          className="bi bi-share"
                          viewBox="0 0 16 16"
                        >
                          <path d="M13.5 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5zm-8.5 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm11 5.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z" />
                        </svg>
                      </button>
                    ) : (
                      <button
                        onClick={() => {
                          handleShareResultWrongClick();
                        }}
                        style={{
                          height: "40px",
                          width: "40px",
                          borderRadius: "7px",
                        }}
                      >
                        <svg
                          xmlns="https://www.w3.org/2000/svg"
                          width="25"
                          height="25"
                          fill="#fdfbee"
                          className="bi bi-share"
                          viewBox="0 0 16 16"
                        >
                          <path d="M13.5 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5zm-8.5 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm11 5.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z" />
                        </svg>
                      </button>
                    ))}
                  <span
                    onClick={() => {
                      isTodayModalOpen(false);
                      setTimeout(() => {
                        setWhatDoYouThinkDataOpen(false);
                      }, 500);
                    }}
                    className="close-button"
                  >
                    &times;
                  </span>
                </>
              )}
            </Modal.Title>
          </Modal.Header>
        ) : (
          <Modal.Header
            className={
              hideButtonsBoolean && changeHeader
                ? "puzzle-case-header"
                : isSuccess
                  ? "success"
                  : "error"
            }
          >
            <Modal.Title className="flex items-start h-100 flex-column">
              <p className="puzzle-case-result-title text-center">
                {isSuccess
                  ? languageString.answerResultGoodTitle
                  : isGenius
                    ? languageString.answerGeniusResultWrongTitle
                    : languageString.answerResultWrongTitle}
              </p>

              {!isYesterdaysDayRiddle ? (
                <div>
                  <p className="puzzle-case-result-title text-start">
                    {hideButtonsBoolean
                      ? langString === "nl"
                        ? `Het goede antwoord is ${
                            result?.attributes?.correctOpenAnswer?.[0] ||
                            result?.attributes?.correctAnswer ||
                            ""
                          }`
                        : `The correct answer is ${
                            result?.attributes?.correctOpenAnswer?.[0] ||
                            result?.attributes?.correctAnswer ||
                            ""
                          }`
                      : savedTime?.solvedIn}
                  </p>
                </div>
              ) : hideButtonsBoolean ? (
                <div>
                  <p className="puzzle-case-result-title text-start">
                    {langString === "nl"
                      ? `Het goede antwoord is ${
                          result?.attributes?.correctOpenAnswer?.[0] ||
                          result?.attributes?.correctAnswer ||
                          ""
                        }`
                      : `The correct answer is ${
                          result?.attributes?.correctOpenAnswer?.[0] ||
                          result?.attributes?.correctAnswer ||
                          ""
                        }`}
                  </p>
                </div>
              ) : null}
            </Modal.Title>
            <Modal.Title className="flex flex-column gap-[15px]">
              {showTextCopied ? (
                <p className="puzzle-case-result-title text-center">Copied</p>
              ) : (
                <>
                  {!hideButtonsBoolean &&
                    (savedTime &&
                    savedTime?.selectedValue?.toLowerCase() ===
                      window.correctAnswer.toLowerCase() ? (
                      <button
                        onClick={() => {
                          handleShareResultGoodClick();
                        }}
                        style={{
                          height: "40px",
                          width: "40px",
                          borderRadius: "7px",
                        }}
                      >
                        <svg
                          xmlns="https://www.w3.org/2000/svg"
                          width="25"
                          height="25"
                          fill="#fdfbee"
                          className="bi bi-share"
                          viewBox="0 0 16 16"
                        >
                          <path d="M13.5 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5zm-8.5 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm11 5.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z" />
                        </svg>
                      </button>
                    ) : (
                      <button
                        onClick={() => {
                          handleShareResultWrongClick();
                        }}
                        style={{
                          height: "40px",
                          width: "40px",
                          borderRadius: "7px",
                        }}
                      >
                        <svg
                          xmlns="https://www.w3.org/2000/svg"
                          width="25"
                          height="25"
                          fill="#fdfbee"
                          className="bi bi-share"
                          viewBox="0 0 16 16"
                        >
                          <path d="M13.5 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5zm-8.5 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm11 5.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z" />
                        </svg>
                      </button>
                    ))}
                  <span
                    onClick={() => isTodayModalOpen(false)}
                    className="close-button2"
                  >
                    &times;
                  </span>
                </>
              )}
            </Modal.Title>
          </Modal.Header>
        )}

        <Modal.Body className="puzzle-case-result-text">
          {whatDoYouThinkDataOpen && (
            <>
              <div className="shadow"></div>
              <div className="what_do_you_think">
                <p>This challenge was:</p>
                <div className="what_do_you_think_body" ref={dropdownRef}>
                  {whatDoYouThinkData.map((item) => {
                    return (
                      <div
                        key={item.type}
                        onClick={() => {
                          onRatingClick(item);
                        }}
                      >
                        <img src={item.img} />
                        <p className="what_do_you_think_body_text">
                          {item.text}
                        </p>
                      </div>
                    );
                  })}
                </div>
              </div>
            </>
          )}
          {!hideButtonsBoolean && (
            <>
              <div
                className="answer-explanation"
                dangerouslySetInnerHTML={{
                  __html: urlify(finalText1),
                }}
              />
              <div
                onClick={() => setWhatDoYouThinkDataOpen(true)}
                className="rate_this_challenge"
              >
                {rateText}
              </div>
              <div
                className="answer-explanation"
                dangerouslySetInnerHTML={{
                  __html: urlify(finalText2),
                }}
              />
            </>
          )}
          {hideButtonsBoolean && (
            <div
              className={`company-leaderboard ${
                changeHeader
                  ? "company-leaderboard--replay"
                  : isSuccess
                    ? "company-leaderboard--success"
                    : "company-leaderboard--error"
              }`}
              aria-label="Jouw teamcompetitie"
            >
              <div className="company-leaderboard-header">
                Jouw teamcompetitie
              </div>
              <ol className="company-leaderboard-list">
                {COMPANY_LEADERBOARD_PLAYERS.map((player, index) => (
                  <li
                    key={`${player.name}-${index}`}
                    className={player.isYou ? "is-you" : undefined}
                  >
                    <span className="company-leaderboard-rank">{index + 1}</span>
                    <img
                      className="company-leaderboard-avatar"
                      src={player.photo}
                      alt=""
                    />
                    <span className="company-leaderboard-name">{player.name}</span>
                    <span className="company-leaderboard-score">{player.score}</span>
                  </li>
                ))}
              </ol>
            </div>
          )}
          {isSuccess &&
            showConfetti &&
            !changeHeader &&
            Array.from({ length: 50 }).map((_, index) => (
              <Confetti key={index} index={index} />
            ))}
        </Modal.Body>
        <Modal.Footer
          className={
            hideButtonsBoolean
              ? "company-leaderboard-footer"
              : isSuccess && !changeHeader
                ? "success"
                : changeHeader
                  ? "f0fcf0"
                  : "error"
          }
        >
          {hideButtonsBoolean ? (
            <button
              type="button"
              className={`company-leaderboard-ok ${
                changeHeader
                  ? "replay"
                  : isSuccess
                    ? "success"
                    : "error"
              }`}
              onClick={() => {
                isTodayModalOpen(false);
                setTimeout(() => {
                  setWhatDoYouThinkDataOpen(false);
                  setIsPuzzleCaseModalClosed(true);
                }, 500);
              }}
            >
              OK
            </button>
          ) : (
          <div
            className={
              changeHeader ? "already-played-footer" : "puzzle-case-footer"
            }
          >
            <div
              className="flex flex-column items-center "
              style={{ gridRow: "1/3", lineHeight: "54px" }}
            >
              <span style={{ fontSize: "45px" }}>{wonThisMonth}</span>
              <span style={{ textAlign: "center", lineHeight: "24px" }}>
                {languageString.titleWonInMonth}
                <br />
                {wonMonthDate}
              </span>
            </div>
            <div
              className="flex flex-column items-center"
              style={{ lineHeight: "24px" }}
            >
              <span>{numbersPlayed}</span>
              <span>{languageString.titlePlayed}</span>
            </div>
            <div
              className="flex flex-column items-center"
              style={{ lineHeight: "24px" }}
            >
              <span>{won}</span>
              <span>{languageString.titleWon}</span>
            </div>
            <div
              className="flex flex-column items-center"
              style={{ lineHeight: "24px" }}
            >
              <span>{streak}</span>
              <span>{languageString.titleStreak}</span>
            </div>
            <div
              className="flex flex-column items-center"
              style={{ lineHeight: "24px" }}
            >
              <span>{maxStreak}</span>
              <span>{languageString.titleMaxStreak}</span>
            </div>
          </div>
          )}
        </Modal.Footer>
      </Modal>
      <Modal
        show={isShareModalOpen}
        onHide={() => {
          setIsShareModalOpen(false);
          setIsModalOpen(true);
        }}
        className="puzzle-case"
      ></Modal>
    </>
  );
};

const PopupWithBackdrop = ({
  isIntroPopupOpen,
  setIsIntroPopupOpen,
  isGenius,
  geniusEnabled,
  geniusPurchaseEnabled,
  langString,
  isPuzzleCaseModalClosed,
  numbersPlayed,
  setIsPuzzleCaseModalClosed,
  hideButtonsBoolean,
}) => {
  if (hideButtonsBoolean) {
    return null;
  }

  //localStorage.removeItem("backdropPart1Shown");

  let backdropPart1Shown = localStorage.getItem("backdropPart1Shown");

  const hasPlayedToday = (() => {
    try {
      const raw = localStorage.getItem("playedIds");
      if (!raw) return false;
      const ids = JSON.parse(raw);
      if (!Array.isArray(ids)) return false;

      const now = new Date();
      return ids.some((i) => {
        const solvedDateRaw = i?.solvedDate;
        if (!solvedDateRaw) return false;
        const d = new Date(solvedDateRaw);
        if (Number.isNaN(d.getTime())) return false;
        return (
          d.getFullYear() === now.getFullYear() &&
          d.getMonth() === now.getMonth() &&
          d.getDate() === now.getDate()
        );
      });
    } catch (e) {
      return false;
    }
  })();

  const getMessagePart1 = () => {
    switch (langString) {
      case "nl":
        return hasPlayedToday
          ? "Hier vind je het menu en de uitleg van vandaag."
          : "Hier vind je het menu en de uitleg van gisteren.";
      default:
        return hasPlayedToday
          ? "Here you’ll find the menu and today’s explanation."
          : "Here you’ll find the menu and yesterday’s explanation.";
    }
  };

  const getMessagePart2 = () => {
    const numberOfGeniusPlayed = localStorage.getItem("numberOfGeniusPlayed");

    if (isGenius === true) {
      return "Click here to go back.";
    } else {
      if (langString === "nl") {
        switch (Number(numberOfGeniusPlayed)) {
          case 0:
            return "Uitdagende genius-challenges wachten hier op je!";
          case 1:
            return "Er wachten nog veel meer uitdagingen op je!";
          default:
            return "De uitdaging van vandaag is voltooid! Geavanceerde genius-challenges wachten hier op je!";
        }
      } else {
        switch (Number(numberOfGeniusPlayed)) {
          case 0:
            return "Advanced genius challenges are waiting for you right here!";
          case 1:
            return "Many more challenges are waiting for you!";
          default:
            return "Today's challenge complete! Advanced genius challenges are waiting for you right here!";
        }
      }
    }
  };

  const getMessagePart3 = () => {
    switch (langString) {
      case "nl":
        return hasPlayedToday
          ? "Tip: Klik hier om direct de uitleg van vandaag te bekijken!"
          : "Tip: Klik hier om direct de uitleg van gisteren te bekijken!";
      default:
        return hasPlayedToday
          ? "Tip: Click here to view today’s explanation right away!"
          : "Tip: Click here to view yesterday’s explanation right away!";
       
    }
  };

  let backdropPart3Shown = localStorage.getItem("backdropPart3NotNeedToShow");
 

   //localStorage.removeItem("backdropPart3NotNeedToShow");
  if (backdropPart3Shown === null && (numbersPlayed === 3 || numbersPlayed === 9 || numbersPlayed === 11)) {
    return (
      <Modal
        show={isPuzzleCaseModalClosed}
        onHide={() => {
          setTimeout(() => {
            //localStorage.setItem("backdropPart3NotNeedToShow", "true");
            setIsPuzzleCaseModalClosed(false)
          }, 200);
        }}
        centered
        className="popup-backdropPart3"
      >
        <Modal.Body
          style={{
            position: "relative",
            width: "16rem",
            padding: "1rem",
            backgroundColor: "#fdfbee",
            borderRadius: "0.25rem",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
            fontFamily: "Union",
            fontSize: "1.5rem",
            textAlign: "center",
            outline: "none",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: "-6px",
              width: "12px",
              height: "12px",
              backgroundColor: "#fdfbee",
              transform: "rotate(45deg)",
            }}
            className="popup-backdropPart3-pointer"
          />
          {getMessagePart3()}
        </Modal.Body>
      </Modal>
    );
  }

  if (backdropPart1Shown === null) {
    return (
      <Modal
        show={isIntroPopupOpen}
        onHide={() => {
          setIsIntroPopupOpen(false);

          setTimeout(() => {
            localStorage.setItem("backdropPart1Shown", "true");
            setIsIntroPopupOpen(true);
          }, 200);
        }}
        centered
        className="popup-backdropPart1"
      >
        <Modal.Body
          style={{
            position: "relative",
            width: "16rem",
            padding: "1rem",
            backgroundColor: "#fdfbee",
            borderRadius: "0.25rem",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
            fontFamily: "Union",
            fontSize: "1.5rem",
            textAlign: "center",
            outline: "none",
            whiteSpace: "pre-line",
          }}
        >
          <div
            style={{
              position: "absolute",
              bottom: "-6px",
              right: "16px",
              width: "12px",
              height: "12px",
              backgroundColor: "#fdfbee",
              transform: "rotate(45deg)",
            }}
          />
          {getMessagePart1()}
        </Modal.Body>
      </Modal>
    );
  } else if (geniusEnabled || geniusPurchaseEnabled) {
    return (
      <Modal
        show={isIntroPopupOpen}
        onHide={() => {
          setIsIntroPopupOpen(false);
        }}
        centered
        className="popup-backdropPart2"
      >
        <Modal.Body
          style={{
            position: "relative",
            width: "16rem",
            padding: "1rem",
            backgroundColor: "#fdfbee",
            borderRadius: "0.25rem",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
            fontFamily: "Union",
            fontSize: "1.5rem",
            textAlign: "center",
            outline: "none",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: "-6px",
              right: "16px",
              width: "12px",
              height: "12px",
              backgroundColor: "#fdfbee",
              transform: "rotate(45deg)",
            }}
          />
          {getMessagePart2()}
        </Modal.Body>
      </Modal>
    );
  }
};

export default PopupWithBackdrop;
